import { render, staticRenderFns } from "./ExhibitList.vue?vue&type=template&id=f117ac6e&scoped=true"
import script from "./ExhibitList.vue?vue&type=script&lang=js"
export * from "./ExhibitList.vue?vue&type=script&lang=js"
import style0 from "./ExhibitList.vue?vue&type=style&index=0&id=f117ac6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f117ac6e",
  null
  
)

export default component.exports